import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listCountry } from '../actions/countryActions'

export default function Country() {
    const dispatch = useDispatch();

    const countryList = useSelector(state => state.countryList);
    const { countries, loading, error } = countryList

    useEffect(() => {
        if (countries == undefined) {
            dispatch(listCountry())
        }else if(countries.length == 0){
            dispatch(listCountry())
        }
    }, [dispatch, countries])
    return (
        <>
        {
            loading ? (
                <option value="0">Loading...</option>
            ) : (
                countries ? (
                    countries.map(countf => (
                        <option key={countf.Id} value={countf.Id}>{countf.Country}</option>
                    ))
                ) : (
                    <option value="0">{error}</option>
                )
            )
        }
        </>

  )
}

